import React, { useEffect, useMemo } from 'react';
import { BlurFilter } from 'pixi.js';
import { useRecoilValue } from 'recoil';

import Background from './Background';
import Board from './Board';

import useLoader from './useLoader';
import { isMenuOpenState } from '@/use/useMenuState';

const Game = () => {
  const { loadAssets } = useLoader();
  const isMenuOpen = useRecoilValue(isMenuOpenState);
  const blurFilter = useMemo(() => new BlurFilter({ strength: 4 }), []);
  const filters = !isMenuOpen ? [] : [blurFilter];

  useEffect(() => {
    loadAssets();
  }, []);

  return (
    <pixiContainer filters={filters}>
      <Background />
      <Board />
    </pixiContainer>
  );
};

export default Game;
